import { render, staticRenderFns } from "./project-unit-team.vue?vue&type=template&id=555a07c8&"
import script from "./project-unit-team.vue?vue&type=script&lang=js&"
export * from "./project-unit-team.vue?vue&type=script&lang=js&"
import style0 from "./project-unit-team.vue?vue&type=style&index=0&id=555a07c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports